import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

type SmsBodyCellProps = {
  smsBody?: string | null;
  className?: string;
};

/** Truncated SMS body in the table; click to open full text in a popover. */
export function SmsBodyCell({ smsBody, className }: SmsBodyCellProps) {
  const text = smsBody?.trim() || "—";
  const isEmpty = text === "—";

  if (isEmpty) {
    return <span className={className}>—</span>;
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={
            className ??
            "max-w-[260px] inline-block cursor-pointer truncate border-none bg-transparent p-0 text-left align-middle text-primary-dark underline-offset-2 hover:text-blue-700"
          }
          aria-label="View full SMS body"
        >
          View
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        side="left"
        className="max-w-md border border-gray-200 bg-white p-3 text-gray-900 shadow-sm"
      >
        <p className="text-xs font-medium text-gray-600">SMS body</p>
        <p className="mt-1 max-h-64 overflow-y-auto whitespace-pre-wrap wrap-break-word text-sm leading-snug text-gray-900">
          {text}
        </p>
      </PopoverContent>
    </Popover>
  );
}
